<template>
  <div class="modal-mask">
    <md-progress-spinner class="modal-accent" md-mode="indeterminate" />
  </div>
</template>

<script>
export default {
  name: 'spinner',
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.1);
  display: table;
  transition: opacity 0.3s ease;
}
.modal-accent {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
